import { connect } from 'react-redux';
import React from 'react';
import { InfoBarMenuButton } from './InfoBarMenuButton';
import { selectInfoBarState } from '../../store/selectors';
import cn from './InfoBar.css.json';
import './InfoBar.css';
const InfoBarBase = (props) => {
    return props.menuButtonCount === 0 ? null : (React.createElement("div", { className: cn.menuButtonContainer }, [...Array(props.menuButtonCount).keys()].map((index) => (React.createElement(InfoBarMenuButton, { key: index, id: props.id, index: index })))));
};
export const InfoBar = connect((state, props) => {
    var _a, _b;
    return ({
        menuButtonCount: (_b = (_a = selectInfoBarState(state, props.id).menuButtons) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0,
    });
})(InfoBarBase);
